import { useEffect } from "react";
import DropdownList from "../../shared/DropdownList";

export default function DropdownContent({ page, htmlAnswer, htmlQuestion }) {
  useEffect(() => {
    setTimeout(function () {
      const hiddenContent = document.getElementById("page-content");
      if (hiddenContent) hiddenContent.classList.add("animated");
    }, 100);
  }, [ page ]);
  useEffect(() => {
    const hiddenContent = document.getElementById("page-content");
    if (hiddenContent) {
      setTimeout(() => {
        hiddenContent.classList.add("animated");
      }, 50);
    }
  }, [ page ]);
  return (
    <article>
      {page && (
        <div
          id="page-content"
          className="z-50 min-h-full p-8 pt-12 mb-4 hideme transe-ease-slow"
        >
          <h1 className="text-center min-[768px]:text-left font-frutiger-light uppercase font-bold text-[#24292e] mb-4 min-[768px]:mb-6">
            {page.title}
          </h1>
          <div className="mt-4 post-content dropdown-list xl:mt-8 float-images-left">
            {page?.pageContent && (
              <DropdownList
                htmlAnswer={htmlAnswer}
                htmlQuestion={htmlQuestion}
                items={page.pageContent}
              />
            )}
          </div>
        </div>
      )}
    </article>
  );
}
